module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.9b70c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/fullscreen-image_hero_768.png
// module id = 4Oj8
// module chunks = 0